import { Component, OnInit, ViewChild } from '@angular/core';
import { DxSchedulerComponent } from 'devextreme-angular';
import { Workflow } from '../../../../Model/Dto/Workflow/Workflow';
import { CatalogService } from '../../../../Services/CatalogManagement/catalog.service';
import { LoginService } from '../../../../Services/login.service';
import { WorkflowService } from '../../../../Services/Workflow/workflow.service';
import { WorkflowplanAppointment } from '../../../../Model/Dto/Workflow/WorkflowplanAppointment';
import { Workflowplan } from '../../../../Model/Dto/Workflow/Workflowplan';
import { HttpErrorResponse } from '@angular/common/http';
import { SystemService } from '../../../../Services/system.service';
import { Message } from '../../../../Model/System/Message';
import { RRule } from 'rrule';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'workflow-plans',
  templateUrl: './workflow-plans.component.html',
  styleUrl: './workflow-plans.component.css'
})
export class WorkflowPlansComponent implements OnInit {
  @ViewChild('workflowPlanScheduler', { static: false }) workflowPlanScheduler!: DxSchedulerComponent;
  workflows: Workflow[] = [];
  selectedWorkflowId: string = '';
  selectedWorkflowplanId: string = '';
  appointmentData: WorkflowplanAppointment[] = [];
  workflowPlans: Workflowplan[] = [];
  schedulerVisible: boolean = false;

  constructor(public workflowService: WorkflowService, public loginService: LoginService, public catalogService: CatalogService, public systemService: SystemService, public translate: TranslateService) {
    this.createUpdateDeleteWorkflowPlan = this.createUpdateDeleteWorkflowPlan.bind(this);
    this.getAppointmentString = this.getAppointmentString.bind(this);
    this.deleteWorkflowplan = this.deleteWorkflowplan.bind(this);
    this.updateWorkflowActiveStatus == this.updateWorkflowActiveStatus.bind(this);
  }

  async ngOnInit() {
    this.workflows = await this.workflowService.getWorkflows(this.loginService.currentCustomer.id);
    this.workflowPlans = await this.workflowService.getWorkflowplans(this.catalogService.catalog.id, this.loginService.currentCustomer.id);
  }

  onGridToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'newWorkflowPlanButtonTemplate'
    });
  }

  onAppointmentFormOpening(e) {
    const form = e.form;

    form.beginUpdate();

    const recurrenceEditor = form.getEditor('recurrenceRule');
    if (recurrenceEditor && (recurrenceEditor._editors[0].editorOptions.items.length == 5)) {
      recurrenceEditor._editors[0].editorOptions.items.splice(0, 1);
    }

    form.on('fieldDataChanged', (args: any) => {
      if (args.dataField === 'repeat') {
        setTimeout(() => {
          const recurrenceEditor = form.getEditor('recurrenceRule');
          if (recurrenceEditor && (recurrenceEditor._editors[0].editorOptions.items.length == 5)) {
            recurrenceEditor._editors[0].editorOptions.items.splice(0, 1);
          }
        });
      }
    });

    form.itemOption("mainGroup.allDay", "visible", false);
    form.itemOption("mainGroup.endDate", "visible", false);
    form.endUpdate();
  }

  customizeColumns(columns) {
    columns.forEach((column) => {
      column.showEditorAlways = true;
    });
  }

  getAppointmentString(rowData: Workflowplan): string {
    if (!rowData.appointment) {
      return '';
    }
    var startDate = rowData.appointment.startDate;
    if (!(startDate instanceof Date)) {
      startDate = new Date(startDate);
    }

    const hours = String(startDate.getUTCHours()).padStart(2, '0');
    const minutes = String(startDate.getUTCMinutes()).padStart(2, '0');

    if (rowData.appointment.recurrenceRule) {
      const rule = RRule.fromString(rowData.appointment.recurrenceRule);
      return rule.toText() + ' at ' + hours + ":" + minutes;
    }
    else {
      return 'on ' + startDate.toDateString() + ' at ' + hours + ":" + minutes;
    }
  }

  getLastRunValue(rowData: Workflowplan): string {
    var lastRun = rowData.lastRun;
    if (!(lastRun instanceof Date)) {
      lastRun = new Date(lastRun);
    }
    if (lastRun.getFullYear() == 1) {
      return '';
    }
    else {
      const hours = String(lastRun.getUTCHours()).padStart(2, '0');
      const minutes = String(lastRun.getUTCMinutes()).padStart(2, '0');
      return lastRun.toDateString() + ' ' + hours + ":" + minutes;
    }

  }
  
  async run(data) {
    try {
      await this.workflowService.runWorkflow(this.catalogService.catalog.id, data.data.workflowId, this.loginService.currentCustomer.id, data.data.id);
      this.systemService.notify(new Message(this.translate.instant("Workflow wurde manuell gestartet.")));
    }
    catch (error) {
      this.systemService.notify(new Message(this.translate.instant("Fehler beim Starten des Workflows.")));
    }
  }

  handlePopupShown() {
    this.workflowPlanScheduler.instance.repaint();
  }

  createNewWorkflowPlan() {
    var newWorkflowPlan = new Workflowplan("",this.catalogService.catalog.id.toString());
    this.workflowPlans.push(newWorkflowPlan);
  }

  deleteWorkflowplan = async(e) => {
    const workflowPlan = this.workflowPlans.find((plan) => plan.id == e.data.id && plan.catalogId == e.data.catalogId && plan.workflowId == e.data.workflowId);

    await this.workflowService.deleteWorkflowplan(workflowPlan, this.loginService.currentCustomer.id);
  }

  updateWorkflowId = async (e, data) => {
    let workflowPlan = this.workflowPlans.find((plan) => plan.id == data.id && plan.catalogId == this.catalogService.catalog.id && plan.workflowId == e.value);

    workflowPlan.workflowId = e.value;
    await this.workflowService.updateOrCreateWorkflowplan(workflowPlan, this.loginService.currentCustomer.id);
    this.workflowPlans = await this.workflowService.getWorkflowplans(this.catalogService.catalog.id, this.loginService.currentCustomer.id);
    this.selectedWorkflowId = e.value;
    this.selectedWorkflowplanId = data.id;
  }

  async updateWorkflowActiveStatus(e, data) {

    if (e.value == e.previousValue) {
      return;
    }
    let workflowPlan = this.workflowPlans.find((plan) => plan.id == data.id && plan.catalogId == this.catalogService.catalog.id);

    workflowPlan.active = e.value;
    if (e.value == true) {
      workflowPlan.timesFailed = 0;
    }
    await this.workflowService.updateOrCreateWorkflowplan(workflowPlan, this.loginService.currentCustomer.id);
    this.workflowPlans = await this.workflowService.getWorkflowplans(this.catalogService.catalog.id, this.loginService.currentCustomer.id);
    this.selectedWorkflowId = data.workflowId;
    this.selectedWorkflowplanId = data.id;
  }

  onAppointmentAdded = async (e) =>  {
    const workflowPlan = this.workflowPlans.find((plan) => plan.id == this.selectedWorkflowplanId && plan.catalogId == this.catalogService.catalog.id && plan.workflowId == this.selectedWorkflowId);

    var appointment = new WorkflowplanAppointment();
    appointment.text = e.appointmentData.text;
    appointment.description = e.appointmentData.description;
    appointment.recurrenceRule = e.appointmentData.recurrenceRule;
    appointment.startDate = new Date(e.appointmentData.startDate);
    appointment.endDate = new Date(e.appointmentData.startDate);
    workflowPlan.appointment = appointment;

    await this.workflowService.updateOrCreateWorkflowplan(workflowPlan, this.loginService.currentCustomer.id);

  }

  onAppointmentDeleted = async (e) => {
    const workflowPlan = this.workflowPlans.find((plan) => plan.id == this.selectedWorkflowplanId && plan.catalogId == this.catalogService.catalog.id && plan.workflowId == this.selectedWorkflowId);
    workflowPlan.appointment = undefined;
    await this.workflowService.updateOrCreateWorkflowplan(workflowPlan, this.loginService.currentCustomer.id);
  }

  onAppointmentUpdated = async (e) => { 
    const workflowPlan = this.workflowPlans.find((plan) => plan.id == this.selectedWorkflowplanId && plan.catalogId == this.catalogService.catalog.id && plan.workflowId == this.selectedWorkflowId);
    e.appointmentData.endDate = e.appointmentData.startDate;
    workflowPlan.appointment = e.appointmentData;
    this.appointmentData = [e.appointmentData];
    await this.workflowService.updateOrCreateWorkflowplan(workflowPlan, this.loginService.currentCustomer.id);
  }

  createUpdateDeleteWorkflowPlan(e) {
    this.selectedWorkflowplanId = e.row.data.id;
    this.selectedWorkflowId = e.row.data.workflowId;
    const workflowPlan = this.workflowPlans.find((plan) => plan.id == this.selectedWorkflowplanId && plan.catalogId == this.catalogService.catalog.id && plan.workflowId == this.selectedWorkflowId);
    if (workflowPlan && workflowPlan.appointment) {
      this.appointmentData = [workflowPlan.appointment];
    }
    else {
      this.appointmentData = [];
    }
    this.schedulerVisible = true;
  }

}



